import { createContext } from 'react';
import { NavigateOptions, To } from 'react-router';

export const StableNavigateContext = createContext<
  (to: To | number, options?: NavigateOptions) => void
>(() => {});
